import t from "@/lang/lang";
import { useBranchesBranchShowQuery } from "@/services/backend/branch/api/branch";
import { parseRTKQueryErrorToSonner } from "@/shared/components/errors/parse-r-t-k-query-error";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { NullUUID } from "@/shared/lib/utilities/uuid";
import { UUID } from "@bitory-gmbh/nidavellir";
import { useEffect } from "react";
import { toast } from "sonner";

export function BranchName(props: { branchId: UUID | null | undefined }) {
  const { branchId } = props;

  const {
    data: branch,
    isLoading,
    error,
  } = useBranchesBranchShowQuery(
    { id: branchId || NullUUID },
    { skip: !branchId || branchId === "" },
  );

  useEffect(() => {
    if (error) {
      toast(...parseRTKQueryErrorToSonner(error));
    }
  }, [error]);

  if (!branchId || branchId === "") {
    return t("- ohne Niederlassung -");
  }

  if (isLoading) {
    return <Skeleton className="h-2 w-32" />;
  }

  if (error) {
    return <span>{t("- Fehler -")}</span>;
  }

  return <span>{branch?.name}</span>;
}
